import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import PageHeading from "../../../../components/common/PageHeading";
import AttachmentsUpload from "../../../../components/common/AttachmentsUpload";
import Notes from "../../../../components/common/Notes";
import ActionsLog from "../../../../components/common/ActionsLog";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";
import BankInformation from "./components/BankInformation";
import AccountingInformation from "./components/AccountingInformation";
import CheckInformation from "./components/CheckInformation";
import BankChangeHistory from "./components/BankChangeHistory";

import { data } from "..";
import { Col, Row } from "antd";

const BankAccountDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("New Bank Account", "1", "", "", ""),
    RightBarMethod("Verify Account", "2", "", "", ""),
  ]),
  RightBarMethod(
    "REPORTS",
    "t2",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Check Register", "3", "", "", "/"),
      RightBarMethod("Deposit Register", "4", "", "", "/"),
      RightBarMethod("Trust Account Balance", "5", "", "", "/"),
      RightBarMethod("Bank Account Association", "6", "", "", "/"),
    ]
  ),
  RightBarMethod("LETTERS", "t3", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("Owner Packets", "7", "", "", "/"),
  ]),
];

function BankAccountDetails() {
  const [bankAccDetails, setBankAccDetails] = useState({});
  const { id } = useParams();

  useEffect(() => {
    const newObject = data.find((item) => {
      return item.id === Number(id);
    });
    setBankAccDetails(newObject);
  }, []);

  return (
    <>
      <div className="bank-account-details">
        <PageHeading heading="Rental Income Account" />
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <BankInformation
              data={
                bankAccDetails?.bankInformation
                  ? bankAccDetails.bankInformation
                  : null
              }
            />
          </Col>
          <Col span={24}>
            <AccountingInformation
              data={
                bankAccDetails?.accountingInformation
                  ? bankAccDetails.accountingInformation
                  : null
              }
            />
          </Col>
          <Col span={24}>
            <CheckInformation
              data={
                bankAccDetails?.checkInformation
                  ? bankAccDetails.checkInformation
                  : null
              }
            />
          </Col>
          <Col span={24}>
            <BankChangeHistory />
          </Col>
          <Col span={24}>
            <ActionsLog />
          </Col>
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={BankAccountDetailsRightBar} />
      </div>
    </>
  );
}

export default BankAccountDetails;
